import { Component } from '@angular/core';
import { environment } from '@environments/environment';
import { EnumEnvs } from '@library/store/config/config.interface';
import { HomesFacade } from '@library/store/homes/homes.facade';
import { LocalStorageService } from '@library/utils/services/local-storage.service';
import { EnergyReportsFacade } from '@store/energy-reports/energy-reports.facade';
import { EnergyReport } from '@store/energy-reports/energy-reports.interface';
import { Subscription, firstValueFrom } from 'rxjs';
import { ControlPageReportsService, getCurentYear, getCurrentMonth } from './control-page-reports.service';
import { CpReportsScaleService } from './cp-reports-body/cp-reports-main-card/cp-reports-month-viewer/cp-reports-scale-selector/cp-reports-scale.service';

@Component({
  selector: 'app-control-page-reports',
  templateUrl: './control-page-reports.component.html',
  styleUrls: ['./control-page-reports.component.scss'],
  providers: [
    ControlPageReportsService,
    CpReportsScaleService,
  ]
})
export class ControlPageReportsComponent {

  environment = environment;
  EnumEnvs = EnumEnvs;

  subscrition =  new Subscription();

  reportGateways$ = this.energyReportsFacade.reportGateways$;

  constructor(
    private energyReportsFacade: EnergyReportsFacade,
    private controlPageReportsService: ControlPageReportsService,
    private homesFacade: HomesFacade,
    private localStorageService: LocalStorageService,
  ) {

  }

  async ngOnInit() {
    // if never seen, show fus compare
    if (!this.localStorageService.getItem('control-seen-bilan')) {
      this.localStorageService.setItem('control-seen-bilan', 'true');
    }

    // unselect measrecards when new home is selected
    this.subscrition.add(this.homesFacade.currentHomeId$.subscribe(async () => {
      const devices = await firstValueFrom(this.reportGateways$);

      // initialize with first device available
      this.controlPageReportsService.reportDevice$.next(devices[0]);

      const reportDevice = await firstValueFrom(this.controlPageReportsService.reportDevice$);
      if (!reportDevice.last_energy_bilan_month || !reportDevice.last_energy_bilan_year) {
        // create a fake report with only date and error
        const fakeReport = {device_id: reportDevice.id, month: getCurrentMonth(), year: getCurentYear()};
        this.energyReportsFacade.setNoReport(fakeReport);
        this.energyReportsFacade.selectReport(fakeReport as EnergyReport);
      }
      else {
        await this.controlPageReportsService.loadReport(reportDevice.id, reportDevice.last_energy_bilan_month, reportDevice.last_energy_bilan_year);
      }
    }));

    this.subscrition.add(this.controlPageReportsService.reportDevice$.subscribe(async reportDevice => {
      if (!reportDevice.last_energy_bilan_month || !reportDevice.last_energy_bilan_year) {
        // create a fake report with only date and error
        const fakeReport = {device_id: reportDevice.id, month: getCurrentMonth(), year: getCurentYear()};
        this.energyReportsFacade.setNoReport(fakeReport);
        this.energyReportsFacade.selectReport(fakeReport as EnergyReport);
      }
      else {
        await this.controlPageReportsService.loadReport(reportDevice.id, reportDevice.last_energy_bilan_month, reportDevice.last_energy_bilan_year);
        this.controlPageReportsService.setTimerange(reportDevice.last_energy_bilan_month, reportDevice.last_energy_bilan_year);
      }
    }));

  }

  ngOnDestroy() {
    this.subscrition.unsubscribe();
  }
}
